export default __webpack_public_path__ + "static/media/mono.b4cdd575.jpeg";